export const DEFAULT_ERROR_STATUS = 0;
/*
 * Custom error type to be used in the Api
 * It enables an easier use of try/catch with async/await
 * and cleaner handling of only this type of ex in stores
 */
export default function ApiError(message, status = DEFAULT_ERROR_STATUS) {
	this.name = 'ApiError';
	this.message = message || 'Api request error.';
	this.stack = new Error(message).stack;
	this.status = status;
}
ApiError.prototype = Object.create(Error.prototype);
ApiError.prototype.constructor = ApiError;

/*
 * Helper function to be used in a catch block
 * to handle Api specific errors in store actions
 */
export function onlyHandleApiError(error, callback) {
	if (error instanceof ApiError) {
		callback();
	} else {
		throw error;
	}
}



// WEBPACK FOOTER //
// ./src/api/helpers/ApiError.js